@if (displayReleaseNotes) {
  <dialog #releaseNotesModal>
    <div [innerHtml]="releaseNotesTemplate"></div>
    <div class="m-t--50 m-b---50">See PPR Manual under the Help link for more details.</div>
    <div class="btn-container txt-center" style="padding-top: 10px">
      <button (click)="closeReleaseNotesModal()" class="secondary" #closeModalButton title="Close Release Notes">Ok</button>
    </div>
  </dialog>
}